import React from 'react';

/**
 * ColorScaleLegend — compact color scale overlay for grid/contour result layers.
 *
 * Props:
 *   title  - layer name
 *   min    - minimum value
 *   max    - maximum value
 *   colors - array of colors (low → high)
 *   inline - static, light-on-white block for print layouts (Wave 5.4) instead of the map overlay
 */
export default function ColorScaleLegend({ title, min, max, colors = [], inline = false }) {
  if (!colors.length || min === undefined || max === undefined) return null;
  const mid = (min + max) / 2;
  const fmt = (v) => {
    const a = Math.abs(v);
    return a >= 1000 ? v.toFixed(0) : a >= 10 ? v.toFixed(1) : v.toFixed(3);
  };

  if (inline) {
    return (
      <div style={{ minWidth: 120, marginBottom: 6 }} data-testid="inline-color-scale">
        <div style={{ fontSize: 9, fontWeight: 600, color: '#11161d', marginBottom: 3 }}>{title}</div>
        <div style={{ height: 9, borderRadius: 2, background: `linear-gradient(to right, ${colors.join(', ')})`, border: '1px solid #8b949e' }} />
        <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 2, fontSize: 8, color: '#30363d', fontFamily: 'monospace' }}>
          <span>{fmt(min)}</span><span>{fmt(mid)}</span><span>{fmt(max)}</span>
        </div>
      </div>
    );
  }

  return (
    <div style={{
      position: 'absolute', bottom: 36, left: 10, zIndex: 6,
      background: 'rgba(13,17,23,0.9)', border: '1px solid rgba(255,255,255,0.1)',
      borderRadius: 8, padding: '8px 10px', minWidth: 150, maxWidth: 230,
      pointerEvents: 'none',
    }}>
      <div style={{ fontSize: 9, fontWeight: 600, color: '#c9d1d9', marginBottom: 5, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
        {title}
      </div>
      <div style={{
        height: 10, borderRadius: 3,
        background: `linear-gradient(to right, ${colors.join(', ')})`,
        border: '1px solid rgba(255,255,255,0.15)',
      }} />
      <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 3, fontSize: 9, color: '#8b949e', fontFamily: 'monospace' }}>
        <span>{fmt(min)}</span>
        <span>{fmt(mid)}</span>
        <span>{fmt(max)}</span>
      </div>
    </div>
  );
}
